import * as Actions    from './actions';
import * as Selectors  from './selectors';
import { compose }     from 'redux';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';


// UI Hooks

export function useIsLoadingConversations() {
  return useSelector(state => Selectors.isLoadingConversations(state));
}


// Use this action to show a toast message.
export function useToast() {
  return compose(useDispatch(), Actions.toast);
}
